import initHelp from '~/help/help';

document.addEventListener('DOMContentLoaded', initHelp);



// WEBPACK FOOTER //
// ./pages/help/show/index.js